import { communityReportState } from '@src/models/communityReportState';

export const communityReportStateLabel: Record<communityReportState, string> = {
  [communityReportState.CREATED]: '접수됨',
  [communityReportState.REJECTED]: '반려됨',
  [communityReportState.DELETED]: '삭제됨',
  [communityReportState.CENSORED]: '스포일러 처리'
};
